<template>
  <div>
    <div>
      <appointment
        v-for="(appointment, index) in appointments"
        :key="index"
        v-model="appointment.value"
        :readonly="readonly"
        :validation-context="validationContext"
        :validation-path="`${validationPath}.${index}`"
        :disable-min-date-constrains="disableMinDateConstrains"
        :multiday="multiday"
      />
    </div>
    <b-form-invalid-feedback
      v-if="showValidation"
      class="mb-2 white-space-pre-line"
      :state="defaultValidationState"
    >
      {{ errorMessages }}
    </b-form-invalid-feedback>
    <div class="mb-2">
      <b-button
        size="sm"
        variant="outline-primary"
        :disabled="readonly"
        @click="addAppointment"
      >
        {{ $t('inputs.appointment.add') }}
      </b-button>
      <b-button
        size="sm"
        variant="outline-dark"
        class="ml-2"
        :disabled="readonly"
        @click="removeAppointment"
      >
        {{ $t('inputs.appointment.remove') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import BaseInput from './mixins/BaseInput';
import ValidatingInput from '../mixins/ValidatingInput';

import Appointment from './Appointment.vue';
import { AVAILABILITY_DATES } from './_types';

export default {
  mixins: [BaseInput, ValidatingInput],
  components: {
    Appointment,
  },
  props: {
    inputName: {
      type: String,
      default: AVAILABILITY_DATES,
    },
    disableMinDateConstrains: Boolean,
    multiday: Boolean,
  },
  data() {
    return {
      appointments: [],
    };
  },
  computed: {
    errorMessages() {
      return Array.isArray(this.defaultValidationErrorMessages)
        ? this.defaultValidationErrorMessages.join('\n')
        : this.defaultValidationErrorMessages;
    },
    showValidation() {
      return !(this.errorMessages instanceof Object);
    },
  },
  created() {
    if (this.value && this.value.length > 0) {
      this.appointments = this.value.map((element) => ({ value: element }));
    }
  },
  watch: {
    appointments: {
      deep: true,
      handler() {
        this.commitValue(this.appointments.map((item) => item.value));
        this.defaultClearValidation();
      },
    },
  },
  methods: {
    addAppointment() {
      const startTime = moment().add(1, 'hour').startOf('hour');
      this.appointments.push({
        value: {
          start: startTime.toISOString(true),
          end: startTime.add(30, 'minutes').toISOString(true),
        },
      });
    },
    removeAppointment() {
      this.appointments.pop();
    },
  },
};
</script>

<style>
.white-space-pre-line {
  white-space: pre-line;
}
</style>
